module.exports = __webpack_public_path__ + "f2ed29706944a06532adf4f3608e4af0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/coppa.png
// module id = 1662
// module chunks = 0